import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker, Polyline, Circle } from '@react-google-maps/api';
import { useParams } from 'react-router-dom';
import io from 'socket.io-client';
import axios from 'axios';
import polyline from '@mapbox/polyline';
import styles from '../../styles/UltimatePage.module.css';

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const apiUrl = 'https://api-backend.full-trucking-service.com';

const mapContainerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'absolute',
  top: 0,
  left: 0,
};

const ShareTrucking = () => {
  const [pin, setPin] = useState('');
  const [isPinValid, setIsPinValid] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [shipperMarker, setShipperMarker] = useState(null);
  const [consigneeMarker, setConsigneeMarker] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 37.7749, lng: -122.4194 });
  const [socket, setSocket] = useState(null);
  const [routeData, setRouteData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const { driverId, expires, shareLinkId } = useParams();
  console.log("📌 Driver ID:", driverId, "Expiration:", expires);


  
  const handlePinSubmit = async () => {
    console.log("📤 Submitting PIN:", { shareLinkId, pin });

    console.log("📤 Submitting PIN:", { shareLinkId, pin });

    if (!shareLinkId) {
      setErrorMessage('Missing Share Link ID.');
      return;
    }
    
    if (!pin) {
      setErrorMessage('Missing PIN.');
      return;
    }
    

    try {
      const response = await axios.post(`${apiUrl}/api/verifyPin`, {
        pinCode: pin,
        shareLinkId: shareLinkId
      });

      console.log("✅ API Response:", response.data);

      if (response.status === 200) {
        setIsPinValid(true);
        setErrorMessage('');
      }
    } catch (error) {
      console.error("❌ API Error:", error.response?.data || error.message);
      setErrorMessage(error.response?.data?.error || 'Invalid PIN or link expired.');
    }
};

  
const getCoordinatesFromAddress = async (address) => {
  try {
      const response = await axios.get(`${apiUrl}/api/geocode`, {
          params: { address }
      });

      if (response.data.status !== "OK" || !response.data.results.length) {
          console.warn(`⚠️ Google Geocoding API failed for address: ${address}`);
          return null;
      }

      return response.data.results[0].geometry.location;
  } catch (error) {
      console.error(`❌ Error fetching coordinates for ${address}:`, error);
      return null;
  }
};


  useEffect(() => {
    if (!isPinValid || !driverId) return;
  
    const fetchDriverLocation = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/getDriverLocation/${driverId}`);
  
        if (response.data && response.data.location) {
          const newLocation = {
            lat: response.data.location.latitude,
            lng: response.data.location.longitude,
          };
  
          console.log("📡 [ShareTrucking] Received driver location:", newLocation);
          setCurrentLocation(newLocation);
  
          setMapCenter(newLocation); // ✅ Mută harta doar prima dată
        } else {
          console.warn("⚠️ [ShareTrucking] No location data found:", response.data);
        }
      } catch (error) {
        console.error("❌ [ShareTrucking] Error fetching driver location:", error);
      }
    };
  
    fetchDriverLocation();
    const interval = setInterval(fetchDriverLocation, 30000); // 🔥 Update la fiecare 30 secunde
  
    return () => clearInterval(interval);
  }, [isPinValid, driverId]);
  

  useEffect(() => {
    if (!isPinValid || !driverId) return;
  
    const fetchDriverRoute = async () => {
      try {
        console.log(`📌 Fetching route for driver: ${driverId}`);

        const response = await axios.get(`${apiUrl}/api/routes/${driverId}`);
        if (!response.data || !response.data.destination) {
          console.warn("❌ No active route found for driver.");
          setRouteData(null);
          return;
        }

        const { origin, destination, waypoints } = response.data;
        console.log(`📍 Route Data: Origin: ${origin}, Destination: ${destination}, Waypoints: ${waypoints}`);

        // 🔥 Convertim waypoint și destinație în coordonate GPS
        const waypointsCoords = waypoints ? await getCoordinatesFromAddress(waypoints) : null;
        const destinationCoords = destination ? await getCoordinatesFromAddress(destination) : null;

        if (waypointsCoords) {
          console.log("✅ Shipper Marker Set:", waypointsCoords);
          setShipperMarker(waypointsCoords);
        }

        if (destinationCoords) {
          console.log("✅ Consignee Marker Set:", destinationCoords);
          setConsigneeMarker(destinationCoords);
        }

        // 🔥 Obținem ruta de la Google Maps API
        const mapsResponse = await axios.get(`${apiUrl}/api/google-directions`, {
          params: { origin, destination, waypoints },
        });

        if (!mapsResponse.data.routes.length) {
          console.warn("❌ No route found in Google Maps API");
          setRouteData(null);
          return;
        }

        const route = mapsResponse.data.routes[0];
        const decodedPolyline = polyline.decode(route.overview_polyline.points).map(([lat, lng]) => ({ lat, lng }));

        const estimatedTime = route.legs.reduce((total, leg) => total + leg.duration.value, 0);
        const estimatedDistance = route.legs.reduce((total, leg) => total + leg.distance.value, 0);

        setRouteData({
          route: decodedPolyline,
          estimatedTime: `${Math.floor(estimatedTime / 3600)}h ${Math.round((estimatedTime % 3600) / 60)}min`,
          estimatedDistance: (estimatedDistance / 1609).toFixed(2) + " miles",
        });

      } catch (error) {
        console.error("❌ Error fetching driver route:", error);
        setRouteData(null);
      }
    };

    fetchDriverRoute();
  }, [isPinValid, driverId]);
  
  // 🔥 Dacă PIN-ul nu este valid, cere-l
  if (!isPinValid) {
    return (
      <div style={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        backgroundColor: 'white', padding: '20px', borderRadius: '10px', textAlign: 'center'
      }}>
        <p>Please enter the PIN to access the location:</p>
        <input
          type="text"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          maxLength={8}
          placeholder="Enter PIN"
          style={{ padding: '10px', fontSize: '16px', marginBottom: '10px', width: '80%' }}
        />
        <button onClick={handlePinSubmit} style={{ padding: '10px 15px', fontSize: '16px' }}>
          Submit
        </button>
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </div>
    );
  }

  // 🔥 Afișare hartă și traseu
  return (
    <LoadScript googleMapsApiKey={googleMapsApiKey}>
      <GoogleMap 
          key={JSON.stringify(currentLocation)} // 🔥 Refresh hartă la schimbarea locației
          mapContainerStyle={mapContainerStyle} 
          center={currentLocation || mapCenter} 
          zoom={14}
      >
          {currentLocation && (
          <>
            <Marker position={currentLocation} label="📍 Driver Location" />
            <Circle
              center={currentLocation}
              radius={500}
              options={{
                fillColor: 'rgba(0, 0, 255, 0.2)',
                strokeColor: 'rgba(0, 0, 255, 0.6)',
                strokeWeight: 2,
              }}
            />
          </>
        )}

        {shipperMarker && <Marker position={shipperMarker} label="📦 Shipper" />}
        {consigneeMarker && <Marker position={consigneeMarker} label="📍 Consignee" />}

       
        {routeData && routeData.route && (
          <Polyline path={routeData.route} options={{ strokeColor: 'blue', strokeOpacity: 0.8, strokeWeight: 4 }} />
        )}
      </GoogleMap>
   {/* 🔥 Containerul cu estimări - apare peste hartă, în colțul din dreapta sus */}
{routeData && (
  <div style={{
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    padding: '10px 15px',
    borderRadius: '8px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 'bold'
  }}>
    <p>📍 Distance: {routeData.estimatedDistance}</p>
    <p>⏳ ETA: {routeData.estimatedTime}</p>
  </div>
)}

    </LoadScript>
  );
};

export default ShareTrucking;
